import { render } from "./TypeView.vue?vue&type=template&id=5bce91ec&ts=true"
import script from "./TypeView.vue?vue&type=script&lang=ts"
export * from "./TypeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__